module.exports = __webpack_public_path__ + "img/on-chain.c80ef6bd.svg";